import { render, staticRenderFns } from "./totalPage.vue?vue&type=template&id=cafadf22&scoped=true&"
import script from "./totalPage.vue?vue&type=script&lang=js&"
export * from "./totalPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cafadf22",
  null
  
)

export default component.exports